import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from './ui/separator';
import { Linkedin, Twitter, Mail, MapPin, FileText, BookOpen } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    platform: [
      { label: "Overview", path: "/platform" },
      { label: "Intelligence Platform", path: "/platform" },
      { label: "Predict Module", path: "/platform" },
      { label: "Assess Module", path: "/platform" },
      { label: "Training Module", path: "/platform" }
    ],
    regions: [
      { label: "Global Coverage", path: "/regions" },
      { label: "EMEA Markets", path: "/regions" },
      { label: "APAC Markets", path: "/regions" },
      { label: "47 Jurisdictions", path: "/regions" }
    ],
    company: [
      { label: "About Us", path: "/about" },
      { label: "Leadership Team", path: "/about" },
      { label: "Our Network", path: "/about" },
      { label: "Contact Us", path: "/contact" }
    ],
    resources: [
      { label: "Get Started", path: "/contact" },
      { label: "Request Demo", path: "/contact" },
      { label: "Case Studies", path: "/platform" },
      { label: "Documentation", path: "/platform" }
    ]
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/">
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent hover:from-blue-300 hover:to-indigo-300 transition-all cursor-pointer">
                GaaS Trust
              </span>
            </Link>
            <p className="mt-4 text-sm text-gray-400 leading-relaxed">
              Governance-as-a-Service platform delivering 90%+ cultural intelligence accuracy across 47 jurisdictions.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="mailto:partnerships@gaas-platform.com" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <div className="mt-6 space-y-2">
              <div className="flex items-center gap-2 text-xs text-gray-400">
                <FileText className="w-4 h-4" />
                <a href="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</a>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-400">
                <BookOpen className="w-4 h-4" />
                <a href="/terms" className="hover:text-blue-400 transition-colors">Terms of Service</a>
              </div>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="font-semibold text-white mb-4">Platform</h3>
            <ul className="space-y-3">
              {footerLinks.platform.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Regions */}
          <div>
            <h3 className="font-semibold text-white mb-4">Regions</h3>
            <ul className="space-y-3">
              {footerLinks.regions.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="bg-gray-800 mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            <span>London, United Kingdom | EMEA & APAC Governance Intelligence</span>
          </div>
          <p>&copy; 2025 GaaS Trust Platform. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;